module.exports = __webpack_public_path__ + "img/opioid_pills.0ebd62da.png";